import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { createPageUrl } from "./utils";
import { getUser, logout } from "./auth/simpleAuth";
import {
  LayoutDashboard,
  Upload,
  User2,
  LogOut,
  Menu,
  X,
  Send,
  Network,
  Settings
} from "lucide-react";
import { Button } from "./components/ui/button";

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Carregar dados do usuário do sistema de autenticação simples
    const userData = getUser();
    setUser(userData);
  }, []);

  const handleLogout = () => {
    try {
      console.log('Iniciando processo de logout');
      // Usar o sistema de autenticação simples para logout
      logout();
      console.log('Logout realizado, redirecionando para login');
      // Usar window.location para forçar um refresh completo da página
      window.location.href = '/login';
    } catch (error) {
      console.error('Erro durante o logout:', error);
    }
  };

  // Helper to check if a route is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Sidebar Backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 z-50 h-full w-64 bg-white border-r transform transition-transform duration-200 ease-in-out lg:translate-x-0 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between p-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-sky-600 rounded-lg flex items-center justify-center">
              <Upload className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold">FileShare</span>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={() => setSidebarOpen(false)}
          >
            <X className="h-5 w-5" />
          </Button>
        </div>

        <nav className="mt-4 px-3">
          <Link
            to={createPageUrl("Dashboard")}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg mb-2 ${
              isActive(createPageUrl("Dashboard")) 
                ? "bg-indigo-50 text-indigo-700" 
                : "text-gray-700 hover:bg-gray-100"
            }`}
            onClick={() => setSidebarOpen(false)}
          >
            <LayoutDashboard className="w-5 h-5" />
            Dashboard
          </Link>
          <Link
            to={createPageUrl("Upload")}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg mb-2 ${
              isActive(createPageUrl("Upload")) 
                ? "bg-indigo-50 text-indigo-700" 
                : "text-gray-700 hover:bg-gray-100"
            }`}
            onClick={() => setSidebarOpen(false)}
          >
            <Upload className="w-5 h-5" />
            Upload
          </Link>
          <Link
            to={createPageUrl("ApiTester")}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg mb-2 ${
              isActive(createPageUrl("ApiTester")) 
                ? "bg-indigo-50 text-indigo-700" 
                : "text-gray-700 hover:bg-gray-100"
            }`}
            onClick={() => setSidebarOpen(false)}
          >
            <Network className="w-5 h-5" />
            API Tester
          </Link>
          <Link
            to={createPageUrl("Operations")}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg mb-2 ${
              isActive(createPageUrl("Operations")) 
                ? "bg-indigo-50 text-indigo-700" 
                : "text-gray-700 hover:bg-gray-100"
            }`}
            onClick={() => setSidebarOpen(false)}
          >
            <Settings className="w-5 h-5" />
            Operações
          </Link>
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-4 border-t">
          <div className="flex flex-col items-center mb-4">
            <div className="w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center text-sky-600 mb-2">
              <User2 size={24} />
            </div>
            <h3 className="font-medium">Administrador</h3>
            <p className="text-sm text-gray-500">Central do Contador</p>
          </div>
          <Button
            variant="outline"
            className="w-full justify-start gap-2"
            onClick={handleLogout}
          >
            <LogOut className="w-4 h-4" />
            Sair
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="lg:pl-64">
        {/* Mobile Header */}
        <header className="lg:hidden bg-white/80 backdrop-blur-md border-b px-4 py-3 sticky top-0 z-30">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu className="h-6 w-6" />
          </Button>
        </header>

        <main className="p-4 md:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
